import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMapDirectionsinline = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 64 64",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		children: [
			/* @__PURE__ */ _jsx("path", { d: "M0 0h64v64H0z" }),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.31 33.728l-.628.778-1.558-1.254.628-.779c.986-1.224 2.029-2.208 3.13-2.947l.831-.557 1.115 1.66-.83.558c-.927.62-1.824 1.467-2.689 2.54zm6.042-3.71l-.993.117-.235-1.986.993-.118c1.418-.167 2.889.002 4.404.5l.95.312-.625 1.9-.95-.312c-1.247-.41-2.426-.546-3.544-.414zm10.092 2.177l-.85-.527 1.054-1.7.85.527c1.178.731 2.31 1.287 3.396 1.67l.943.333-.666 1.886-.943-.333C28 33.618 26.74 33 25.444 32.195zm8.18 3.065l-.999.016-.031-2 1-.016a7.912 7.912 0 0 0 3.455-.845l.895-.446.892 1.79-.895.446a9.912 9.912 0 0 1-4.316 1.055z",
				fill: "currentColor",
				fillRule: "nonzero"
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "currentColor",
				strokeWidth: 2,
				strokeLinecap: "square",
				strokeLinejoin: "round",
				d: "M23 5v43.069L5 59V15.937zm36 0v43.069L41 59V15.937zM23 5v43.069L41 59V15.937z"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M50 35s5-5.814 5-9.37c0-2.557-2.239-4.63-5-4.63s-5 2.073-5 4.63c0 3.556 5 9.37 5 9.37z",
				stroke: "currentColor",
				strokeWidth: 2,
				strokeLinecap: "square",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M50 27a1 1 0 1 0 0-2 1 1 0 0 0 0 2z",
				fill: "currentColor"
			})
		]
	})
});
export default SvgMapDirectionsinline;
